import { Component, OnInit } from '@angular/core';

export interface FaqItem {
  question: string;
  answer: string;
  open?: boolean;
}

export interface FaqCategory {
  title: string;
  items: FaqItem[];
}

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss']
})
export class HelpCenterComponent implements OnInit {
  searchQuery: string = '';
  activeCategoryIndex: number = 0;

  faqCategories: FaqCategory[] = [
    {
      title: 'Booking & Enquiries',
      items: [
        {
          question: 'How do I rent equipment on Aluguloo?',
          answer: 'Browse equipment categories or use search to find the machinery you need. Choose your rental dates and location, review equipment specifications, and proceed to book or send an enquiry directly through the platform.'
        },
        {
          question: 'What is an LPO and why is it needed?',
          answer: 'A Local Purchase Order (LPO) is a formal commercial document issued by the Customer to the Vendor confirming rental terms, duration, and agreed pricing. You can generate or upload LPOs directly within your Aluguloo account.'
        },
        {
          question: 'Can I rent equipment with a certified operator?',
          answer: 'Yes. Equipment listings indicate whether equipment is supplied with an operator or as dry hire. When renting with an operator, the vendor provides a licensed, certified UAE heavy machinery operator.'
        }
      ]
    },
    {
      title: 'Timesheets & Tracking',
      items: [
        {
          question: 'How are equipment working hours tracked?',
          answer: 'Aluguloo provides a digital Timesheet system where operational hours, overtime, and standby periods are logged and signed off by the site supervisor and machine operator.'
        },
        {
          question: 'What happens if equipment breaks down on site?',
          answer: 'Log breakdown hours immediately in the digital timesheet. The vendor is responsible for prompt repair or supplying a replacement machine. Breakdown hours are excluded from rental charges.'
        }
      ]
    },
    {
      title: 'Billing & Payments',
      items: [
        {
          question: 'Does Aluguloo collect payment from customers?',
          answer: 'No. Aluguloo operates as a digital intermediary marketplace. Rental payments, deposits, and invoice settlements are handled directly between Customer and Vendor in accordance with the agreed LPO.'
        },
        {
          question: 'How are invoices generated?',
          answer: 'Vendors can generate standardized, UAE VAT-compliant invoices using Aluguloo’s built-in tools, which sync with verified timesheets and agreed quotation rates.'
        }
      ]
    },
    {
      title: 'Vendor Onboarding',
      items: [
        {
          question: 'How do I register and list equipment as a Vendor?',
          answer: 'Navigate to vendor registration on the platform portal. Complete your profile by uploading your UAE Trade License, equipment registration cards (Mulkiya), and insurance certificates.'
        },
        {
          question: 'What documentation is required for machinery listings?',
          answer: 'Vendors must provide valid UAE vehicle registration (Mulkiya), comprehensive commercial insurance coverage, and mandatory third-party safety inspection certificates.'
        }
      ]
    }
  ];

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleFaq(item: FaqItem): void {
    item.open = !item.open;
  }

  selectCategory(index: number): void {
    this.activeCategoryIndex = index;
  }

  get displayedItems(): FaqItem[] {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) {
      return this.faqCategories[this.activeCategoryIndex]?.items || [];
    }
    const all: FaqItem[] = [];
    for (const cat of this.faqCategories) {
      for (const item of cat.items) {
        if (
          item.question.toLowerCase().includes(q) ||
          item.answer.toLowerCase().includes(q)
        ) {
          all.push(item);
        }
      }
    }
    return all;
  }
}
